import { MessageTemplateCategoryAdminDto } from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const CategoriesTableColumns =
  (): ColumnConfiguration<MessageTemplateCategoryAdminDto>[] => [
    {
      id: 'name',
      value: 'name',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
      title: 'Name',
    },
    {
      id: 'stageKey',
      value: 'stageKey',
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Stage',
      sortable: true,
    },
    {
      id: 'sortOrder',
      value: 'sortOrder',
      isNumeric: true,
      shouldDisablePadding: false,
      title: 'Sort Order',
      sortable: true,
    },
  ];
